import { SESSION_FORMAT_LABELS, type SessionFormat } from "@klarify/constants";
import { type LucideIcon, Phone, Users, Video } from "lucide-react";

export type LabeledOption = { id: string; label: string };

export const initialsFor = (
	firstName: string | null | undefined,
	lastName: string | null | undefined,
): string => {
	const f = firstName?.trim()?.[0] ?? "";
	const l = lastName?.trim()?.[0] ?? "";
	return `${f}${l}`.toUpperCase() || "?";
};

export const initialsForName = (name: string): string => {
	const tokens = name
		.split(/\s+/)
		.map((t) => t.trim())
		.filter(Boolean)
		.slice(0, 2);
	const initials = tokens.map((t) => t[0] ?? "").join("");
	return initials.toUpperCase() || "?";
};

export const SESSION_FORMAT_ICONS: Record<SessionFormat, LucideIcon> = {
	IN_PERSON: Users,
	VIDEO: Video,
	PHONE: Phone,
};

export const SESSION_FORMAT_LIST: {
	id: SessionFormat;
	label: string;
	Icon: LucideIcon;
}[] = [
	{
		id: "IN_PERSON",
		label: SESSION_FORMAT_LABELS.IN_PERSON,
		Icon: SESSION_FORMAT_ICONS.IN_PERSON,
	},
	{
		id: "VIDEO",
		label: SESSION_FORMAT_LABELS.VIDEO,
		Icon: SESSION_FORMAT_ICONS.VIDEO,
	},
	{
		id: "PHONE",
		label: SESSION_FORMAT_LABELS.PHONE,
		Icon: SESSION_FORMAT_ICONS.PHONE,
	},
];
